import React, { useState } from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import ManualPoolAssignment, {
    isValidPoolAssignment,
    PoolSplit,
} from '../../components/reusables/ManualPoolAssignment';
import { PoolResponse } from '../../api/generated/models';
import './ManualCatModal.scss';

interface ManuallyCategoriseModalProps {
    visible: boolean;
    selectedRowCount: number;
    onClose: () => void;
    onSave: (splits: { poolId: number; splitPercent: number }[]) => void;
    pools: PoolResponse[];
    isLoadingPools: boolean;
    isSaving: boolean;
}

const ManualCatModal: React.FC<ManuallyCategoriseModalProps> = ({
    visible,
    selectedRowCount,
    onClose,
    onSave,
    pools,
    isLoadingPools,
    isSaving,
}) => {
    const [poolSplits, setPoolSplits] = useState<PoolSplit[]>([
        { poolId: '', splitPercent: '100' },
    ]);

    const isValid = isValidPoolAssignment(poolSplits);

    const handleSave = () => {
        if (!isValid) return;

        onSave(
            poolSplits.map((split) => ({
                poolId: Number(split.poolId),
                splitPercent: Number(split.splitPercent),
            }))
        );
    };

    const handleClose = () => {
        setPoolSplits([{ poolId: '', splitPercent: '100' }]);
        onClose();
    };

    return (
        <Modal
            visible={visible}
            title="Manual Assignment"
            onCancel={handleClose}
            className="project-manual-assignment-modal overflow-visible"
            modalStyle={{ width: '640px' }}
            footer={
                <div className="project-manual-assignment-modal__footer">
                    <Button
                        kind="secondary"
                        onClick={handleClose}
                        disabled={isSaving}
                    >
                        Cancel
                    </Button>
                    <Button
                        kind="primary"
                        onClick={handleSave}
                        disabled={!isValid || isSaving}
                    >
                        Save assignment
                    </Button>
                </div>
            }
        >
            <p className="project-manual-assignment-modal__selection-summary">
                {selectedRowCount}{' '}
                {selectedRowCount === 1 ? 'Project' : 'Projects'} Selected
            </p>

            <ManualPoolAssignment
                pools={pools}
                isLoadingPools={isLoadingPools}
                poolSplits={poolSplits}
                onPoolSplitsChange={setPoolSplits}
            />
        </Modal>
    );
};

export default ManualCatModal;
